import gql from "graphql-tag";

export const REQUEST_RESET_QUERY = gql`
  mutation RequestReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;



// WEBPACK FOOTER //
// ./src/screens/Login/ForgotForm/queries.ts